/** @jsxImportSource @emotion/react */

import { CloseCircleOutlined } from "@ant-design/icons";
import { Checkbox, Modal } from "antd";
import { ReactComponent as IconComment } from "assets/common/icons/modal/comment-dots.svg";
import { ReactComponent as IconNext } from "assets/common/icons/modal/next.svg";
import Loading from "components/common/Loading";
import { ModalTypeValue } from "enums/modalType";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import { useState } from "react";
import { selectAllAnnouncement, selectIsLoading } from "store/announcement";
import { selectOpenSubModal, setOpenSubModal } from "store/master";
import { AnnouncementItemType } from "types/announcement";

import { ModalInformationStyle } from "./style.index";

const ModalInformation = () => {
  const openModal = useAppSelector(selectOpenSubModal);
  const dispatch = useAppDispatch();

  // const [announcementList, setAnnouncementList] = useState<
  //   AnnouncementItemType[] | null
  // >(null);
  const [announcementActive, setAnnouncementActive] =
    useState<AnnouncementItemType | null>(null);
  const announcementList = useAppSelector(selectAllAnnouncement);
  const isLoading = useAppSelector(selectIsLoading);
  // const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleChangeContent = (value: AnnouncementItemType) => {
    setAnnouncementActive(value);
  };

  // const getData = async () => {
  //   try {
  //     setIsLoading(true);
  //     const { data } = await AnnouncementApi.getAnnouncement({ type: 1 });
  //     if (data.status === ResponseCode.SUCCESS) {
  //       setAnnouncementList(data.data);
  //       !!data.data.length && setAnnouncementActive(data.data[0]);
  //     }
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   getData();
  // }, []);

  return (
    <Modal
      open={openModal === ModalTypeValue.INFORMATION}
      centered
      onCancel={() => dispatch(setOpenSubModal(ModalTypeValue.CLOSE))}
      css={ModalInformationStyle.wrapper}
      closeIcon={<CloseCircleOutlined />}
      title={
        <>
          <Checkbox />
          <span>Không hiển thị nữa</span>
        </>
      }
      footer={<div css={ModalInformationStyle.footer} />}
    >
      <div css={ModalInformationStyle.mainContent}>
        <div css={ModalInformationStyle.header}>
          <span>THÔNG BÁO MỚI TỪ ACV88</span>
        </div>
        {isLoading ? (
          <Loading height={500} center />
        ) : (
          <div css={ModalInformationStyle.contentWrap}>
            <div css={ModalInformationStyle.sideBar}>
              {announcementList?.map((item, index) => (
                <div
                  onMouseEnter={() => handleChangeContent(item)}
                  key={index}
                  css={ModalInformationStyle.sideBarItem}
                  className={item.id === announcementActive?.id ? "active" : ""}
                >
                  <IconComment />
                  <span>{item.title}</span>
                  <IconNext />
                </div>
              ))}
            </div>
            <div
              data-comp="content"
              css={ModalInformationStyle.content}
              dangerouslySetInnerHTML={{
                __html: announcementActive?.content || "",
              }}
            ></div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ModalInformation;
